import { render, staticRenderFns } from "./VisitaControlloEcgEdit.vue?vue&type=template&id=26fd1718&scoped=true"
import script from "./VisitaControlloEcgEdit.vue?vue&type=script&lang=js"
export * from "./VisitaControlloEcgEdit.vue?vue&type=script&lang=js"
import style0 from "./VisitaControlloEcgEdit.vue?vue&type=style&index=0&id=26fd1718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fd1718",
  null
  
)

export default component.exports